<div class='sidebar'>
    <img src="assets/images/logo.svg" alt="logo" class="logo">

    <div class="nav-menu">
        @for (item of items(); track item.route) {
            <div class='item'
                 #rla='routerLinkActive'
                 routerLinkActive='active'
                 [routerLink]=[item.route]
                 (click)='itemClicked.emit(item)'>

                <mat-icon>{{item.icon}}</mat-icon>
                <span>{{ item.name }}</span>
            </div>
        }
    </div>
    <div>
        <ng-content></ng-content>
    </div>
</div>
